const MuiAccordion = {
  variants: [
    {
      props: { variant: 'gray' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.gray.A100,
        boxShadow: 'none',
        '&:before': {
          display: 'none',
        },
        '& .MuiAccordionSummary-root': {
          paddingLeft: 0,
          paddingRight: 0,
          minHeight: 'fit-content',
          '&.Mui-expanded': {
            minHeight: 'fit-content',
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
        '& .MuiAccordionSummary-content': {
          marginTop: 0,
          marginBottom: 0,
          '&.Mui-expanded': {
            marginTop: 0,
            marginBottom: 0,
          },
        },
      }),
    },
  ],
};

export default MuiAccordion;
